export default `
    <link href='/snippets-style/style.css' rel='stylesheet' />
    <p>La FavBet efectuezi rapid și în siguranță tranzacții de depunere și de retragere . Ai nevoie doar de un cont de utilizator pentru a te bucura de serviciile și produsele noastre. Depui, câștigi și retragi fără niciun comision!</p>
    <a href="/deposit-skrill" style="margin-right: 10px"><img src="/images/snippetsMedia/payments/skrill_logo.png" alt="skrill-payment" class="payments-img"></a>
    <a href="/deposit-neteller"><img src="/images/snippetsMedia/payments/neteller_logo.png" alt="neteller-payment" class="payments-img"></a>
`;
